module.exports = __webpack_public_path__ + "static/media/CTLI_3-391w.2b23f01a.png";